var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-footer',[_c('p',{staticClass:"footer-copyright mb-0 py-3 text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright: "),_c('a',{attrs:{"href":"http://www.tys.uz"}},[_vm._v(" tys.uz ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }